module.exports = __webpack_public_path__ + "img/gjn-login.42534afe.svg";